export default __webpack_public_path__ + "static/media/B2.7c280c21.mp3";